import React from 'react';

import UndoAndRedo from './UndoAndRedo';
import FormatTextBlock from './FormatTextBlock';
import FormatTextStyle from './FormatTextStyle';
import FormatListBlock from './FormatListBlock';
import Insert from './Insert';
import Attached from './Attached';

function Divider() {
  return <div className="divider" />;
}

type Props = {
  undoAndRedo?: boolean;
  textBlock?: boolean;
  textStyle?: boolean;
  listBlock?: boolean;
  insert?: boolean;
  attached?: boolean;
  link?: boolean;
};

const ToolbarPlugin: React.FC<Props> = (props) => {
  const {
    undoAndRedo = true,
    textBlock = true,
    textStyle = true,
    listBlock = true,
    insert = true,
    attached = true,
    link = true,
  } = props;

  return (
    <div className="iva-toolbar">
      {undoAndRedo && (
        <React.Fragment>
          <UndoAndRedo />
          <Divider />
        </React.Fragment>
      )}
      {textBlock && (
        <React.Fragment>
          <FormatTextBlock />
          <Divider />
        </React.Fragment>
      )}
      {textStyle && (
        <React.Fragment>
          <FormatTextStyle link={link} />
          <Divider />
        </React.Fragment>
      )}
      {listBlock && (
        <React.Fragment>
          <FormatListBlock />
          <Divider />
        </React.Fragment>
      )}
      {insert && (
        <React.Fragment>
          <Insert />
          <Divider />
        </React.Fragment>
      )}
      {attached && (
        <React.Fragment>
          <Attached />
          <Divider />
        </React.Fragment>
      )}
    </div>
  );
};

export default ToolbarPlugin;
